import React, { FC, useEffect } from 'react';
import { Case, CaseStateAction, OperatorProps } from '../../../../@types/TemplateOperators';
import { ArgsInput, ArgsSelect } from './BasicComponents';
import { Button } from '../../../Button';
import { useSwitchConfig } from '../../../../hooks/useTemplateList';

const options = [
  { label: 'Equal To', value: 'eq' },
  { label: 'Not Equals', value: 'ne' },
  { label: 'Less Than', value: 'lt' },
  { label: 'Less Than or Equal', value: 'lte' },
  { label: 'Greater Than', value: 'gt' },
  { label: 'Greater Than or Equal', value: 'gte' }
];

const Switch: FC<OperatorProps> = ({ step, handleArgsChange }) => {
  const [state, dispatch] = useSwitchConfig(step.args[0]);

  useEffect(() => {
    handleArgsChange([state]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <>
      {state.cases.map(CaseHolder(dispatch))}
      <div className="flex mt-6 w-1/2">
        <ArgsInput
          initialValue={state.default.toString()}
          onChange={(val) => dispatch({ type: 'setDefault', val })}
          label="default"
        />
        <Button className="ml-6" onClick={() => dispatch({ type: 'addCase' })} title="+" />
      </div>
    </>
  );
};

const CaseHolder = (dispatch: React.Dispatch<CaseStateAction>) => {
  return function (caseItem: Case, idx: number) {
    return (
      <div key={`case-holder-${idx}}`} className="flex mt-0 w-full">
        <div className="flex-col mt-6 w-1/4 mr-6">
          If Value
          <ArgsSelect
            maxVisible={2}
            options={options}
            onChange={(val) => dispatch({ type: 'setOperator', idx, val })}
            value={caseItem.compare[0].operator}
          />
        </div>
        <div className="flex-col mt-6 w-1/3 mr-6">
          Compare To
          <div className="mt-5">
            <ArgsInput
              initialValue={caseItem.compare[0].compareTo as string}
              onChange={(val) => dispatch({ type: 'setCompareTo', idx, val })}
            />
          </div>
        </div>
        <div className="flex-col mt-6 w-1/3">
          Return
          <div className="mt-5">
            <ArgsInput
              initialValue={caseItem.returns as string}
              onChange={(val) => dispatch({ type: 'setReturns', idx, val })}
            />
          </div>
        </div>
      </div>
    );
  };
};

export default Switch;
